import { css } from '@emotion/css';

export const emptyBlockStyle = (height: string | number, width: string): string => css({
  width,
  height
});
